export const HOMETOWNS_BUSINESS_SORT_TYPE = {
  LATEST: 'LATEST',
  AMOUNT_DESC: 'AMOUNT_DESC',
  DEADLINE_ASC: 'DEADLINE_ASC',
  RATE_DESC: 'RATE_DESC',
  SUPPORT_DESC: 'SUPPORT_DESC',
} as const;

export const DEFAULT_HOMETOWNS_BUSINESS_SORT_TYPE =
  HOMETOWNS_BUSINESS_SORT_TYPE.LATEST;

export const HOMETOWNS_BUSINESS_SORT_TYPE_LABEL = {
  [HOMETOWNS_BUSINESS_SORT_TYPE.LATEST]: '최신등록순',
  [HOMETOWNS_BUSINESS_SORT_TYPE.AMOUNT_DESC]: '모금액 많은순',
  [HOMETOWNS_BUSINESS_SORT_TYPE.DEADLINE_ASC]: '종료 임박순',
  [HOMETOWNS_BUSINESS_SORT_TYPE.RATE_DESC]: '모금율 높은순',
  [HOMETOWNS_BUSINESS_SORT_TYPE.SUPPORT_DESC]: '응원 많은순',
} as const;
